<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'تقرير التحضير والادخال'" :to="{name: 'reports.review'}">    تقرير التحضير والادخال</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">


                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                            تقرير التحضير والادخال
                                        </h4>
                                    </div>
                                    <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item">

                                </li>

                                      </ul>

                                      </div>
                                </div>

                            </div>
                            <div class="widget-content widget-content-area">

                                <form @submit.prevent="getIndexData(1)" v-if="1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                        <div class="col-md-6 mt-2">
                                          <label for="">التاريخ من</label>
                                          <date-picker v-model="data.searching.from" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">التاريخ إلى</label>
                                          <date-picker v-model="data.searching.to" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                       
                                        
                                        <div class="col-md-4 mt-4">
                                          <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>

                                        </div>
                                    </div>
                                </form>
                                <div class="table-responsive">
                                  <div class="col-md-12" v-if="data.data.data">
                                    <button class="btn btn-success" @click.prevent="print">
                                      <i class="fa fa-print"></i> طباعة
                                    </button>
                                    <button class="btn btn-success ml-2" @click.prevent="exportPrepareExcel">
                                     <i class="fa fa-excel"></i> تصدير Excel
                                    </button>
                                  </div>
                                  <table class="table table-bordered mb-4" v-if="data.data.data">
                                    <thead>
                                      <tr>
                                        <th>اسم التقرير</th>
                                        <th>من تاريخ</th>
                                        <th>إلى تاريخ</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>تقرير التحضير والادخال</td>
                                        <td>{{ data.searching.from }}</td>
                                        <td>{{ data.searching.to }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <div class="col-md-12" id="printMe">
                                    <table class="table table-bordered mb-4" id="printMe" v-if="data.data.data">
                                        <thead>
                                            <tr>
                                              <th>المعلم</th>
                                              <th v-for="hh in data.data.headers" colspan="2">{{ hh }}</th>
                                           
                                            </tr>
                                            <tr>
                                            <th>#</th>
                                            <template v-for="hh in data.data.headers">
                                              <th>التحضير</th>
                                              <th>بيانات التقرير</th>
                  
                                            </template>
                                            
                                          </tr>
                                        </thead>
                                        <tbody>
                                          
                                          <tr v-for="teacher in data.data.teachers">
                                            <th>{{ teacher.name }} </th>
                                            <template v-for="hh in data.data.headers">
                                              <th  :style="'background: ' + (data.data.data[hh][teacher.id] ? (data.data.data[hh][teacher.id][0].result2 ? 'green;': 'red;') : 'red;')">
                                              {{ data.data.data[hh][teacher.id] ? '' : ''}} 
                                              <i class="fa" :class="(data.data.data[hh][teacher.id] ? (data.data.data[hh][teacher.id][0].result2 ? 'fa-check': 'fa-times') : 'fa-times')"></i>
                                            </th>

                                              <th  :style="'background: ' + (data.data.data[hh][teacher.id] ? (data.data.data[hh][teacher.id][0].result ? 'green;': 'red;') : 'red;')">
                                                {{ data.data.data[hh][teacher.id] ? '' : ''}} 
                                                <i class="fa" :class="(data.data.data[hh][teacher.id] ? (data.data.data[hh][teacher.id][0].result ? 'fa-check': 'fa-times') : 'fa-times')"></i>
                                              </th>
                                             
                                            </template>
                                            
                                          </tr>
                                        </tbody>
                                    </table>
                                  </div>
                                  
                                  
                                </div>

                            </div>
                        </div>

                    </div>

                </div>


            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import VueDatetimeJs from 'vue-datetime-js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import * as XLSX from "xlsx";

export default {
  components: {
    datePicker: VueDatetimeJs,
    Treeselect
  },
  data() {
    return {
      chartOptions: {
            chart: {
              width: 380,
              type: 'donut',
            },
            plotOptions: {
              pie: {
                startAngle: -90,
                endAngle: 270
              }
            },
            labels: ['اجمالى الحضور', 'اجمالى الغياب', 'اجمالى الاستأذان', 'اجمالى التأخير'],
            dataLabels: {
              enabled: false,
            },
            fill: {
              type: 'gradient',
            },
            legend: {
              formatter: function(val, opts) {
                return val + " - " + opts.w.globals.series + '%'
              }
            },
            title: {
              text: ''
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
          },
      printData: {
      },
      data: {
        data: {},
        searching:{
            to: '',
            from: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      },
       options: [],
       stages: [],
       groups: [],
       lessons: [],
       students: [],
       searchingMode: 0,
       stage: {},
       group: {},
    };
  },
  created(){
  },
  methods: {
     exportPrepareExcel() {
      const rows = [];

      // Report info
      rows.push(["اسم التقرير", "من تاريخ", "إلى تاريخ"]);
      rows.push([
        "تقرير التحضير والادخال",
        this.data.searching.from,
        this.data.searching.to
      ]);

      rows.push([]);

      // Headers
      const headerRow1 = ["المعلم"];
      const headerRow2 = ["#"];

      this.data.data.headers.forEach(h => {
        headerRow1.push(h, "");
        headerRow2.push("التحضير", "بيانات التقرير");
      });

      rows.push(headerRow1);
      rows.push(headerRow2);

      // Data
      this.data.data.teachers.forEach(teacher => {
        const row = [teacher.name];

        this.data.data.headers.forEach(h => {
          let record = null;

          if (
            this.data.data.data &&
            this.data.data.data[h] &&
            this.data.data.data[h][teacher.id] &&
            this.data.data.data[h][teacher.id][0]
          ) {
            record = this.data.data.data[h][teacher.id][0];
          }

          row.push(record && record.result2 ? "نعم" : "لا");
          row.push(record && record.result ? "نعم" : "لا");
        });

        rows.push(row);
      });

      const ws = XLSX.utils.aoa_to_sheet(rows);
      ws["!rtl"] = true;

      const cols = [{ wch: 25 }];
      this.data.data.headers.forEach(() => {
        cols.push({ wch: 15 }, { wch: 18 });
      });
      ws["!cols"] = cols;

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "التحضير والادخال");

      XLSX.writeFile(wb, "preparation-report.xlsx");
    },
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    print(){
      setTimeout(() => {
      this.print_element('printMe', 'تقرير التحضير والادخال');

      }, 3000);
    },
    onSearchStage(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'stage');
      }
    },
    onSearchGroup(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'group');
      }
    },
    search(loading, w, vm, type){
      this.$baseApi.get('/reports/absences?pluck=1&search='+w+'&pluckType='+type).then((response)=>{
            if(loading){
            loading(false);
            }
            if(response.data.code == 200){
              if(type == 'stage'){
                this.stages = response.data.data.options;
              }
              if(type == 'group'){
                this.groups = response.data.data.options;
              }
              if(type == 'lesson'){
                this.lessons = response.data.data.options;
              }
              if(type == 'student'){
                this.students = response.data.data.options;
              }
            }else{
                alert(response.data.error.error);
            }
        });
    },

    getGroups(val){
      this.$baseApi.get('/reports/absences?pluck=1&i='+val.id+'&pluckType=group').then((response)=>{
            
            if(response.data.code == 200){
              
              this.groups = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
    
    getLessons(val){
      this.$baseApi.get('/reports/absences?pluck=1&group='+this.data.searching.group_id+'&i='+val.id+'&pluckType=lesson').then((response)=>{
            
            if(response.data.code == 200){
              
              this.lesson = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
    getStudents(val){
      this.$baseApi.get('/reports/absences?pluck=1&lesson='+this.data.searching.lesson_id+'&i='+val.id+'&pluckType=student').then((response)=>{
            
            if(response.data.code == 200){
              
              this.students = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
    clcDays(){
      const hijriMonthDays = [
      30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29,
    ]; // Fixed number of days per Hijri month

    const daysInYear = hijriMonthDays.reduce((acc, days) => acc + days, 0);
      let from = this.data.searching.from;
      let to = this.data.searching.to;
      let f = from.split("/");
      let t = to.split("/");
    const hijriYearDifference = t[0] - f[0];
    const hijriMonthDifference = t[1] - f[1];
    const hijriDayDifference = t[2] - f[2];

    const daysDifference = (
      hijriYearDifference * daysInYear +
      hijriMonthDifference * 30 + // Approximating with 30 days per Hijri month
      hijriDayDifference
    );
return daysDifference;
    },
      getIndexData(page){
        if(this.data.searching.from == '' || this.data.searching.to == ''){
          return;
        }
        // if(this.clcDays() != 3){
        //   this.sweetAlert('لابد من إدخال 4 ايام بشكل صحيح', 'error');

        //   return;
        // }
        this.$baseApi.get('/reports/teacher-review?data=' + 1, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
              this.data.data = response.data.data;
              // this.data.data = response.data.data;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    },
    makePerc(n, t){
      if(n == 0 || t == 0){
        return 0;
      }
      return (n/t) * 100;
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  },
   watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.searching.stage_id = newValue.id;
    },
    group(newValue) {
      this.data.searching.group_id = newValue.id;
    },
  }
};
</script>
<style>
</style>
